function decodeEntities(str = '') {
  const el = document.createElement('textarea');
  el.innerHTML = str;
  return el.value;
}
function patientData() {
  return {
    // -------- state ----------
    practitionerID: null,
    patients: [],
    filteredPatientsData: [], // kept for your empty-state checks
    searchQuery: '',
    previousSearchQuery: '',
    sortBy: null,     // 'patientName' | 'register_date' | null (null = no sorting)
    sortOrder: null,   // 'asc'  | 'desc' | null (null = no sorting)
    serverPagination: null, // { currentPage, totalPages, pageSize, returnedCount, totalItems }
    currentPage: 1,
    itemsPerPage: 10,
    isLoading: false,   // true while fetching list
    hasFetched: false,
    showPatientForm: false,
    showPatientFormSuccess: false,
    successTimeoutId: null,
    termsPatientForm: false,
    pagesToShow: 5,
    fetchError: false,
    addUserIDinDJ: '',
    isAwaitingResponse: false,
    deleteScriptIDinDJ:'',
    committedSearch: '',        
    lastQueryWasEmpty: true, 

    notification: { message: '', status: 'ok' },
    isUrlSuccessParam: false,
    anchorSelector: '.patients__content', 
    scrollOffset: 0, 

    // -------- utils ----------
    normalizeDate(dateString) {
      const isFormattedDate = /^\d{2}\/\d{2}\/\d{4}$/.test(dateString);
      if (isFormattedDate) return dateString;
      return this.formatDate(dateString);
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) return '—';
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day   = String(date.getDate()).padStart(2, '0');
      const year  = String(date.getFullYear()).slice(-2);
      return `${day}/${month}/${year}`;
    },

    removeURLParam(param) {
      const url = new URL(window.location);
      const urlParams = new URLSearchParams(url.search);
      if (urlParams.has(param)) {
        urlParams.delete(param);
        window.history.replaceState({}, document.title, `${url.pathname}?${urlParams}`);
        this.isUrlSuccessParam = false;
      }
    },

    // Build query with page, search, and sort parameters
    buildQuery(page = 1) {
      const params = new URLSearchParams();
      if (Number(page) > 1) params.set('page', String(page));
      const q = this.committedSearch.trim();
      if (q.length) {
        params.set('search', q);
      }
      // Add sort parameters only if explicitly set (not null/undefined)
      if (this.sortBy && this.sortOrder) {
        params.set('sortBy', this.sortBy);
        params.set('sortOrder', this.sortOrder);
      }
      let queryString = params.toString();
      // Replace %40 (@) with literal @ for search queries
      // Keep %2B (+) encoded to preserve it as literal + (not space)
      if (q.length) {
        queryString = queryString.replace(/%40/g, '@');
      }
      return queryString;
    },

    resetSearchAndReload() {
      this.searchQuery = '';
      this.previousSearchQuery = '';
      this.committedSearch = '';
      this.lastQueryWasEmpty = true;
      this.currentPage = 1;
      return this.fetchPatients(1);
    },

    searchNow() {
      this.committedSearch = this.sanitizeInput(this.searchQuery || '');
      this.lastQueryWasEmpty = this.committedSearch.length === 0;
      this.previousSearchQuery = this.committedSearch;
      this.fetchPatients(1);
    },
    

    isURLParamsSuccess() {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('patient_success')) {
        this.showPatientForm = true;
        this.showPatientFormSuccess = true;
        this.isUrlSuccessParam = true;

        this.successTimeoutId = setTimeout(() => {
          if (this.successTimeoutId) {
            this.showPatientForm = false;
            this.showPatientFormSuccess = false;

            this.removeURLParam('patient_success');
            this.successTimeoutId = null;
          }
        }, 10000);
      }
    },

    getScrollOffset() {
      // Adjust these pixel values to your header heights
      const mobileOffset = 10; // e.g. sticky nav height on mobile
      const desktopOffset = 107; // e.g. sticky nav height on desktop
      return window.innerWidth < 750 ? mobileOffset : desktopOffset;
    },
    
    jumpToDashboard() {
      const el = document.querySelector(this.anchorSelector || '.patients__dashboard');
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.pageYOffset - this.getScrollOffset();
      window.scrollTo({ top: y, behavior: 'smooth' });
    },
    
    jumpToDashboardNextTick() {
      const doScroll = () => this.jumpToDashboard();
      if (typeof this.$nextTick === 'function') this.$nextTick(doScroll);
      else requestAnimationFrame(doScroll);
    },

    isValidName(name) {
      const s = (name || '').trim();
    
      // length
      if (s.length < 2 || s.length > 80) return false;
    
      // disallow digits and most symbols
      if (/[0-9_<>{}\[\]()/\\|@#$%^*&+=~`!?,:;"]/u.test(s)) return false;
    
      // allow letters (incl. accents) + spaces + apostrophe + hyphen + dot (not at ends)
      if (!/^[\p{L}](?:[\p{L}\p{M}\s'.-]*[\p{L}\p{M}])$/u.test(s)) return false;
    
      // prevent runs of punctuation/spaces
      if (/[ '.-]{2,}/.test(s)) return false;
    
      return true;
    },

    get totalPatientsCount() {
      // Prefer server total; fall back gracefully
      const p = this.serverPagination;
      if (p?.totalItems != null) return Number(p.totalItems);
      if (p?.returnedCount != null) return Number(p.returnedCount);
      return this.patients.length; // last resort
    },
    
    get patientsLabel() {
      return this.totalPatientsCount === 1 ? 'Patient' : 'Patients';
    }, 

    // -------- init ----------
    async init(practitionerID, itemsPerPage, deleteScriptIDinDJ, addUserIDinDJ) {

      this.practitionerID = `gid://shopify/Customer/${practitionerID}`;
      this.itemsPerPage = itemsPerPage ? itemsPerPage : 10;

      this.deleteScriptIDinDJ = deleteScriptIDinDJ;
      this.addUserIDinDJ = addUserIDinDJ;

      // start on page 1 (centralised fetch)
      await this.fetchPatients(1);

      this.isURLParamsSuccess();
    },
    sortLocal() {
      const field = this.sortBy;
      const order = this.sortOrder;

      this.patients.sort((a, b) => {
        let valA = (a[field] || '').toString().toLowerCase();
        let valB = (b[field] || '').toString().toLowerCase();

        if (field === 'register_date') {
          const parseDate = (dateStr) => {
            if (!dateStr) return new Date(0);
            const clean = dateStr.trim();
            const parts = clean.includes('/') ? clean.split('/') : clean.split('-');
            const [day, month, year] = parts.map(Number);
            if (!year || !month || !day) return new Date(0);
            return new Date(year, month - 1, day);
          };

          const dA = parseDate(a.register_date);
          const dB = parseDate(b.register_date);
          return order === 'asc' ? dA - dB : dB - dA;
        }
        return order === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      });
    },

    // -------- API fetch (server-side pagination/search/sort) ----------
    async fetchPatients(page = 1) {
      // Prevent concurrent calls
      if (this.isLoading || window.__mainPatientsCSLoaded) {
        //console.log('PatientData: Already fetching, skipping duplicate call');
        return;
      }
      
      this.isLoading = true;
      this.fetchError = false;
    
      try {
        const qs = this.buildQuery(page);
        const baseUrl = '/apps/documents/v1/practitioner-view/patient-orders';
        const url = qs ? `${baseUrl}?${qs}` : baseUrl;

        const apiToken = window.MicroserviceConfig?.apiKey; 
        const subKey = window.MicroserviceConfig?.subKey; 
        const headers = {
            'apiKey': apiToken,
            'Ocp-Apim-Subscription-Key': subKey,
            'Accept': 'application/json'
        };

        const response = await fetch(url, { method: 'GET', headers, credentials: 'same-origin' });

        if (!response.ok) throw new Error(`Request failed: ${response.status}`);

        const json = await response.json();
        //console.log('🔹 Patient Orders:', json);

        const items = json?.data?.items || [];
        // console.log('🔹 Patient itemsitemsitems:', items);

        // Map patient data directly from patient-orders response
        this.patients = items.map(order => {
          const patientId = order.patientId || order.patientCustomerId || order.patientResourceId?.replace(/\D/g, '');
          return {
            id: order.patientResourceId || order.patientId || '',
            name: order.patientName || '',
            email: order.email || '',
            register_date: this.normalizeDate(order.date_created || order.connectionDate),
            total_orders: order.totalOrdersCount ?? 0,
            total_order_value: order.totalOrderValueIncGst
              ? `$${order.totalOrderValueIncGst.toFixed(2)}`
              : '$0.00',
            product_subscription_active: !!order.hasActiveSubscription,
            last_order_date:
              order.lastOrderDate && order.lastOrderDate !== 'Never'
                ? this.normalizeDate(order.lastOrderDate)
                : '—',
            is_new: Boolean(order.isNewPatient)
          };
        });

        //console.log('🔹 Patients:', this.patients);
        // Removed sortLocal() - sorting is now server-side

        // Pagination
        const p = json?.data?.pagination || {};
        this.serverPagination = {
          currentPage: Number(p.currentPage ?? page ?? 1),
          totalPages: Number(p.totalPages ?? 1),
          pageSize: Number(p.pageSize ?? 0),
          returnedCount: this.patients.length,
          totalItems: Number(p.totalItems ?? this.patients.length),
        };
        this.filteredPatientsData = this.patients;
        this.currentPage = this.serverPagination.currentPage;
      } catch (err) {
        console.error('Patients fetch error:', err);
        this.fetchError = true;
        this.patients = [];
        this.filteredPatientsData = [];
        this.showNotification({ message: 'Could not load patients.', status: 'error' });
      } finally {
        this.isLoading = false;
        this.hasFetched = true;
      }
    },

    // -------- formatting labels ----------
    formatSortBy() {
      const labels = {
        'patientName':    'Name',
        'email':          'Email',
        'connectionDate': 'Connection Date',
        'totalOrders':    'Total Orders',
        'totalOrderValue':'Total Order Value',
        'lastOrderDate':  'Last Order Date',
      };
      return labels[this.sortBy] ?? 'Connection Date New–Old';
    },

    formatSortOrder() {
      if (!this.sortOrder || !this.sortBy) return '';

      const alphabetic = ['patientName', 'email'];
      const dateFields  = ['connectionDate', 'lastOrderDate'];
      const numericFields = ['totalOrders', 'totalOrderValue'];

      if (alphabetic.includes(this.sortBy)) {
        return this.sortOrder === 'asc' ? 'A–Z' : 'Z–A';
      }
      if (dateFields.includes(this.sortBy)) {
        return this.sortOrder === 'asc' ? 'Oldest–Newest' : 'Newest–Oldest';
      }
      if (numericFields.includes(this.sortBy)) {
        return this.sortOrder === 'asc' ? 'Low–High' : 'High–Low';
      }
      return '';
    },

    // -------- pagination getters (server is source of truth) ----------
    get totalPages() {
      return Number(this.serverPagination?.totalPages) || 1;
    },

    get isEmptyList() {
      if (!this.hasFetched) return false;
      const noSearch = this.searchQuery.trim().length === 0;
      return noSearch && this.totalPatientsCount === 0;
    },

    get filteredPatients() {
      // server already returned the page slice
      return this.patients;
    },

    get paginatedPatients() {
      // keep same alias used by your template
      return this.patients;
    },

    get visiblePages() {
      const half = Math.floor(this.pagesToShow / 2);
      let start = this.currentPage - half;
      let end   = this.currentPage + half;

      if (start < 1) {
        start = 1;
        end = Math.min(this.pagesToShow, this.totalPages);
      }
      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(1, this.totalPages - this.pagesToShow + 1);
      }
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    // -------- actions ----------
    async changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.jumpToDashboard();
        await this.fetchPatients(page); // adds ?page=2 etc
      }
    },

    async sort(field, order = null) {
      // Map field names to API field names
      const fieldMap = {
        'name':           'patientName',
        'patientName':    'patientName',
        'email':          'email',
        'register_date':  'connectionDate',
        'date_created':   'connectionDate',
        'date':           'connectionDate',
        'connectionDate': 'connectionDate',
        'total_orders':   'totalOrders',
        'total_order_value': 'totalOrderValue',
        'last_order_date':   'lastOrderDate',
      };

      const apiField = fieldMap[field] ?? field;

      // If same field clicked, toggle order; otherwise use provided order or default to 'asc'
      if (this.sortBy === apiField) {
        this.sortOrder = order ?? (this.sortOrder === 'asc' ? 'desc' : 'asc');
      } else {
        this.sortBy    = apiField;
        this.sortOrder = order ?? 'asc';
      }

      this.currentPage = 1;
      await this.fetchPatients(1);
    },

    async onSearchInput() {
      // call this after a small debounce from your search box
      if (this.searchQuery !== this.previousSearchQuery) {
        this.previousSearchQuery = this.searchQuery;
        await this.fetchPatients(1);
      }
    },

    clearSuccessTimeout() {
      if (this.successTimeoutId) {
        clearTimeout(this.successTimeoutId);
        this.successTimeoutId = null;
      }
    },

    closePatientForm() {
      this.clearSuccessTimeout();
    
      // Hide the popup
      this.showPatientForm = false;
    
      // Wait a short moment until it's visually closed, then reset form
      setTimeout(() => {
        this.showPatientFormSuccess = false;
        this.resetFormFields();
      }, 300); // 300ms = enough for CSS transition to finish
    },

    openPatientForm() {
      this.resetFormFields();
      this.clearSuccessTimeout();
      this.showPatientForm = true;
    },

    resetFormFields() {
      const root = document.querySelector('.patients__content-popup');
      const body = root?.querySelector('.popup__cotnent-body');
      const formContent = root?.querySelector('.form__cotnent');
      const formSuccess = root?.querySelector('.form__success');
    
      // clear errors & inputs
      root?.querySelector('#first_name_custom')?.closest('.field')?.classList.remove('error');
      root?.querySelector('#patient_email')?.closest('.field')?.classList.remove('error');
    
      const name = root?.querySelector('#first_name_custom'); if (name) { name.value = ''; name.setAttribute('value',''); }
      const email = root?.querySelector('#patient_email');    if (email){ email.value = ''; email.setAttribute('value',''); }
    
      const terms = root?.querySelector('#patient_terms'); if (terms) terms.checked = false;
    
      // revert success → form
      body?.classList.remove('success-form');
      if (formContent) formContent.classList.remove('hidden');
      if (formSuccess) formSuccess.style.display = 'none';
    
      // Alpine state
      this.termsPatientForm = false;
      this.showPatientFormSuccess = false;
      this.clearNotification();
    },

    showNotification(notification, timeout = 5000) {
      this.notification = { ...notification };
      setTimeout(() => { this.clearNotification(); }, timeout);
    },

    clearNotification() {
      this.notification = { message: '', status: 'ok' };
    },

    async removePatient(patientID, patientEmail) {
      this.isAwaitingResponse = true;

      const taskId = this.deleteScriptIDinDJ;
      const url = `/apps/datajet/task/${taskId}`;

      const data = {
        store: true,
        customer_id: patientID,
        customer_email: patientEmail,
        invited_id: this.practitionerID,
      };

      await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then(async (res_data) => {
        this.isAwaitingResponse = false;
        this.showNotification({ message: res_data.message, status: res_data.status });

        if (res_data.status === 'ok') {
          //await this.refreshPatients();
          await this.resetSearchAndReload();
        }
      })
      .catch((err) => {
        this.isAwaitingResponse = false;
        console.error(err);
        this.showNotification({ message: 'Something went wrong.', status: 'error' });
      });
    },

    async refreshPatients() {
      await this.fetchPatients(this.currentPage || 1);
    },

    sanitizeInput(str) {
      // Remove HTML and script tags
      const div = document.createElement('div');
      div.innerText = str;
      const clean = div.textContent || div.innerText || '';
      return clean.replace(/<[^>]*>?/gm, '').trim();
    },

    async validateAndAddPatient() {
      const firstNameInput = document.querySelector('#first_name_custom');
      const emailInput     = document.querySelector('#patient_email');
    
      const nameValue = firstNameInput.value.trim();
    
      // block HTML and encoded tags
      const unsafePattern = /<[^>]*>|&lt;[^&]*&gt;/gi;
      if (!nameValue || unsafePattern.test(nameValue) || !this.isValidName(nameValue)) {
        firstNameInput.parentElement.classList.add('error');
        this.showNotification({ message: 'Please enter a valid name', status: 'error' });
        return;
      } else {
        firstNameInput.parentElement.classList.remove('error');
      }
    
      // --- Email validation (your existing logic) ---
      const emailValue = emailInput.value.trim();
      const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(emailValue)) {
        emailInput.parentElement.classList.add('error');
        this.showNotification({ message: 'Please enter a valid email address', status: 'error' });
        return;
      } else {
        emailInput.parentElement.classList.remove('error');
      }
    
      await this.addPatient();
    },

    getInviteDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const hours = String(currentDate.getHours()).padStart(2, '0');
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');

      const timezoneOffset = currentDate.getTimezoneOffset();
      const timezoneHours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
      const timezoneMinutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');
      const timezoneSign = timezoneOffset > 0 ? '-' : '+';

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${timezoneSign}${timezoneHours}:${timezoneMinutes}`;
    },

    async addPatient() {
      this.isAwaitingResponse = true;

      const taskId = this.addUserIDinDJ;
      const url = `/apps/datajet/task/${taskId}`;

      // visible fields
      const patient_email = document.querySelector('#patient_email');
      const patient_name  = document.querySelector('#first_name_custom');

      const formattedDate = this.getInviteDate();

      // hidden fields
      const invited_from                  = document.querySelector('input[name="invited_from"]')?.value || '';
      const invited_from_company_name     = document.querySelector('input[name="invited_from_company_name"]')?.value || '';
      const invited_from_practitioner_name= document.querySelector('input[name="invited_from_practitioner_name"]')?.value || '';
      const invited_from_finops           = document.querySelector('input[name="invited_from_finops"]')?.value || '';
      const local_date_time               = document.querySelector('input[name="local_date_time"]')?.value || '';
      const customer_type                 = document.querySelector('input[name="customer_type"]')?.value || '';
      const cookie                        = document.querySelector('input[name="cookies_block"]')?.value || '';

      const data = {
        store: true,
        customer_email: patient_email?.value || '',
        customer_name:  decodeEntities(patient_name?.value || ''), 
        register_date:  formattedDate,
        invited_id:     this.practitionerID,

        invited_from,
        invited_from_company_name,
        invited_from_practitioner_name,
        invited_from_finops,
        local_date_time,
        customer_type,
        cookie
      };

      await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
      .then((response) => response.json())
      .then(async (res_data) => {
        if (res_data.status === 'ok') {
      
          await this.refreshPatients();
      
          // 🔑 Show success via Alpine state (not manual DOM)
          this.showPatientFormSuccess = true;
      
          this.isAwaitingResponse = false;
          return;
        }
      
        if (res_data.status === 'warning' || res_data.status === 'error') {
          const { message, status } = res_data;
          this.showNotification({ message, status });
          this.isAwaitingResponse = false;
        }
      })
      .catch((error) => {
        this.isAwaitingResponse = false;
        this.showNotification({ message: 'Something went wrong. More information in the developer console', status: 'error' });
        console.error('Error:', error);
      });
    },
  };
}